const Sanitizer = () => {

	const sanitizeNumber = (number) => {
		return !isNaN(number) ? parseFloat(number) : 0.0;
	};

	const sanitizeLink = (link) => {
		if(!link) return "";
		
		const map = {
			"<": "&lt;",
			">": "&gt;",
			'"': "&quot;",
			"'": "&#x27;",
		};
		const reg = /[<>"']/gi;
		return link.replace(reg, (match) => map[match]);
	};
	
	return {
		sanitizeNumber,
		sanitizeLink,
	};
};

export default Sanitizer;
